<template>
  <ion-page v-disable-swipe-back>
    <ion-header class="ion-no-border">
      <ion-toolbar
        :color="step === 5 ? 'primary' : undefined"
        class="-not-fixed">
        <ion-buttons slot="start">
          <ion-button v-if="step > 1 && step < 5" @click="step -= 1"
            ><ion-icon
              slot="start"
              :src="require('@lib/assets/icons/icon_zurueck.svg')"></ion-icon>
          </ion-button>
          <back-button
            v-else
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
            :color="step === 5 ? 'light' : undefined">
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content
      :color="step === 5 ? 'primary' : undefined"
      ref="content"
      :fullscreen="true">
      <ion-grid
        v-if="step !== 0"
        fixed
        class="ion-padding"
        style="display: flex; flex-direction: column; min-height: 100%">
        <ion-row class="ion-text-center" v-if="step < 5">
          <ion-col>
            <div class="c-stepper ion-margin-top">
              <ion-icon
                :src="require('@lib/assets/icons/roodie.svg')"
                size="large" />
              <div class="c-stepper__bar">
                <template v-for="(value, name) in stepData" :key="name">
                  <div
                    class="c-stepper__dot"
                    :class="{
                      '-done': step >= name,
                    }"
                    :style="
                      'width:' + 100 / Object.keys(stepData).length + '%'
                    "></div>
                </template>
              </div>
              <div class="c-stepper__text">
                <b>{{ stepData[step].text }}</b>
              </div>
            </div>
          </ion-col>
        </ion-row>
        <template class="" v-if="step == 1">
          <ion-row>
            <ion-col size="12" size-md>
              <ion-item lines="none">
                <ion-label position="stacked">Geburtsdatum</ion-label>
                <!-- <ion-datetime
                  v-if="isPlatform('mobile')"
                  cancel-text="Abbrechen"
                  done-text="Fertig"
                  displayFormat="DD.MM.YYYY"
                  pickerFormat="DD.MM.YYYY"
                  placeholder="TT.MM.JJJJ"
                  v-model="formInput['BirthDate']"
                  @ionFocus="
                    if (formInput['BirthDate'] === '')
                      formInput['BirthDate'] = '1990-01-01';
                  "
                ></ion-datetime> -->
                <ion-input
                  v-imask="{
                    mask: Date,
                  }"
                  type="text"
                  inputmode="numeric"
                  :value="formInput['BirthDate']"
                  placeholder="TT.MM.JJJJ"
                  @accept="imaskOnAccept($event, 'BirthDate')"
                  @complete="imaskOnComplete"
                  @ionChange="imaskOnChange($event, 'BirthDate')">
                </ion-input>
              </ion-item>
              <input-error id="BirthDate" />
            </ion-col>

            <ion-col size="12" size-md>
              <ion-item lines="none">
                <ion-label position="stacked">Versicherungsnummer</ion-label>
                <ion-input
                  placeholder=""
                  v-model="formInput['ExternalId']"
                  type="number"
                  inputmode="decimal"></ion-input>
              </ion-item>
              <ion-row class="ion-margin-top">
                <ion-col size="auto">
                  <ion-icon
                    :src="require('@lib/assets/icons/info.svg')"></ion-icon>
                </ion-col>
                <ion-col>
                  <ion-text color="primary" class="u-xsmall">
                    Roodie kann nur von Versicherten mit einer
                    <b>ARAG Krankenvollversicherung</b> (ausgenommen Basis-/
                    Standard-/Notlagentarif) genutzt werden. Ihre
                    Versicherungsnummer finden Sie auf den Briefen der ARAG
                    Versicherung immer direkt beim
                    <a
                      href="#"
                      @click.prevent="
                        $store.commit('setShowPolicyNumber', true)
                      "
                      ><u>Betreff</u></a
                    >. Oder gehen Sie in der ARAG Gesundheits-App dazu einfach
                    im Menü auf "Mein Profil".
                  </ion-text>
                </ion-col>
              </ion-row>
              <input-error id="ExternalId" />
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-item lines="none">
                <ion-checkbox
                  v-model="formInput['TermsAccepted']"
                  color="primary"
                  slot="start"></ion-checkbox>
                <ion-label
                  class="ion-text-wrap"
                  color="primary"
                  style="font-size: small"
                  >Ich habe die
                  <!-- <a
                    href="#"
                    @click.prevent="
                      openInfoModal(
                        'Datenschutzerklärung',
                        generalPrivacyPolicy
                      )
                    "
                  > -->
                  <!-- <a
                    href="https://www.roodie-health.com/arag/datenschutz"
                    target="_blank"
                  > -->
                  <a
                    href="#"
                    @click.prevent="
                      $browser.open({
                        url: 'https://www.roodie-health.com/arag/datenschutz',
                      })
                    ">
                    <u>Datenschutzinformationen</u></a
                  >
                  gelesen und nehme sie zur Kenntnis.
                </ion-label>
              </ion-item>
              <input-error id="TermsAccepted" />
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-item lines="none">
                <ion-checkbox
                  v-model="formInput['AGB']"
                  color="primary"
                  slot="start"></ion-checkbox>
                <ion-label
                  class="ion-text-wrap"
                  color="primary"
                  style="font-size: small"
                  >Ich habe die
                  <!-- <a
                    href="#"
                    @click.prevent="
                      openInfoModal(
                        'Allgemeine Nutzungsbedingungen',
                        generalUsagePolicy
                      )
                    "
                  > -->
                  <!-- <a
                    href="https://www.roodie-health.com/arag/agb"
                    target="_blank"
                  > -->
                  <a
                    href="#"
                    @click.prevent="
                      $browser.open({
                        url: 'https://www.roodie-health.com/arag/agb',
                      })
                    ">
                    <u>Nutzungsbedingungen</u></a
                  >
                  gelesen und akzeptiere sie.</ion-label
                >
              </ion-item>
              <input-error id="AGB" />
            </ion-col>
          </ion-row>
        </template>

        <template class="" v-if="step == 2">
          <ion-row>
            <ion-col size="12" size-md>
              <ion-item lines="none">
                <ion-label position="stacked">E-Mail Adresse</ion-label>
                <ion-input
                  placeholder="adresse@mail.com"
                  v-model="formInput['Email']"
                  type="email"></ion-input>
              </ion-item>
              <input-error id="Email" />
            </ion-col>

            <ion-col size="12" size-md>
              <ion-item lines="none">
                <ion-label position="stacked">Mobilnummer</ion-label>
                <ion-input
                  placeholder="+49XXXXXXXXXX"
                  v-model="formInput['Msisdn']"
                  type="tel"></ion-input>
              </ion-item>
              <ion-row class="c-help">
                <ion-col size="auto">
                  <ion-icon :icon="helpCircle"></ion-icon>
                </ion-col>
                <ion-col>
                  Wir schicken Ihnen einen Code per SMS an diese Nummer.
                </ion-col>
              </ion-row>
              <input-error id="Msisdn" />
            </ion-col>
          </ion-row>

          <ion-button
            fill="outline"
            @click="
              sendVerifySms();
              hasCode = true;
              formInput.MsisdnCode = '';
            "
            :disabled="sendCodeCountdown !== 30"
            >{{
              hasCode && !$store.state.errors.Msisdn
                ? "Code erneut senden"
                : "Code senden"
            }}&nbsp;
            <span v-if="sendCodeCountdown !== 30" slot="end"
              >({{ sendCodeCountdown }})</span
            ></ion-button
          >

          <template v-if="hasCode && !$store.state.errors.Msisdn && !$store.state.errors.General">
            <ion-row>
              <ion-col size="12">
                <ion-item lines="none">
                  <ion-label
                    position="stacked"
                    class="ion-text-wrap"
                    style="width: 133%; max-width: 133%"
                    >Geben Sie hier bitte den Sicherheitscode ein:</ion-label
                  >
                  <ion-input
                    style="width: 236px; letter-spacing: 16px"
                    class="ion-text-center u-xlarge"
                    v-model="formInput['MsisdnCode']"
                    type="number"
                    autocomplete="one-time-code"
                    inputmode="decimal"
                    ref="codeInput"></ion-input>
                </ion-item>
              </ion-col>
            </ion-row>
          </template>
        </template>

        <template class="" v-if="step == 3">
          <ion-row>
            <ion-col size-md>
              <ion-item lines="none">
                <ion-label position="stacked">Anrede</ion-label>
                <ion-select
                  v-model="formInput['Initials']"
                  placeholder="Frau/Herr"
                  cancel-text="Abbrechen"
                  interface="action-sheet"
                  :interfaceOptions="{ header: 'Anrede' }">
                  <ion-select-option value="F">Frau</ion-select-option>
                  <ion-select-option value="M">Herr</ion-select-option>
                </ion-select>
              </ion-item>
              <input-error id="Initials" />
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12" size-md="6">
              <ion-item lines="none">
                <ion-label position="stacked">Vorname</ion-label>
                <ion-input
                  v-model="formInput['Firstname']"
                  autocapitalize="on"></ion-input>
              </ion-item>
              <input-error id="Firstname" />
            </ion-col>
            <ion-col size="12" size-md="6">
              <ion-item lines="none">
                <ion-label position="stacked">Nachname</ion-label>
                <ion-input
                  v-model="formInput['Lastname']"
                  autocapitalize="on"></ion-input>
              </ion-item>
              <input-error id="Lastname" />
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="8" size-md>
              <ion-item lines="none">
                <ion-label position="stacked">Straße</ion-label>
                <ion-input
                  v-model="formInput['Street']"
                  autocapitalize="on"></ion-input>
              </ion-item>
              <input-error id="Street" />
            </ion-col>
            <ion-col size="4" size-md>
              <ion-item lines="none">
                <ion-label position="stacked">Hausnr.</ion-label>
                <ion-input v-model="formInput['Housenumber']"></ion-input>
              </ion-item>
              <input-error id="Housenumber" />
            </ion-col>
          </ion-row>
          <ion-row align-items-center>
            <!-- <ion-col size="12" size-md>
              <ion-item lines="none">
                <ion-label position="stacked">Stiege/Tür</ion-label>
                <ion-input v-model="formInput['xxxxxxxxxxx']"></ion-input>
              </ion-item>
            </ion-col> -->
            <ion-col size="4" size-md>
              <ion-item lines="none">
                <ion-label position="stacked">PLZ</ion-label>
                <ion-input type="number" v-model="formInput['Zip']"></ion-input>
              </ion-item>
              <input-error id="Zip" />
            </ion-col>
            <ion-col size="8" size-md>
              <ion-item lines="none">
                <ion-label position="stacked">Ort</ion-label>
                <ion-input
                  v-model="formInput['City']"
                  autocapitalize="on"></ion-input>
              </ion-item>
              <input-error id="City" />
              <!--               
              <ion-item lines="none">
                <ion-label position="stacked">Ort</ion-label>
                <ion-select
                  v-model="formInput['Country']"
                  placeholder="Bitte wählen"
                >
                  <ion-select-option value="Wien">Wien</ion-select-option>
                  <ion-select-option value="XXX">XXX</ion-select-option>
                </ion-select>
              </ion-item> 
              <input-error id="Country" />-->
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size-md>
              <ion-item lines="none">
                <ion-label position="stacked">Land</ion-label>
                <ion-select
                  v-model="formInput['Country']"
                  cancel-text="Abbrechen"
                  disabled>
                  <ion-select-option>Deutschland</ion-select-option>
                  <ion-select-option>Länderliste fehlt</ion-select-option>
                </ion-select>
              </ion-item>
              <input-error id="Country" />
            </ion-col>
          </ion-row>

          <!-- <ion-row>
            <ion-col size-md>
              <ion-item lines="none">
                <ion-label position="stacked">Land</ion-label>
                <ion-input v-model="formInput['Land']"></ion-input>
              </ion-item>
              <input-error id="Land" />
            </ion-col>
          </ion-row> -->
        </template>

        <template class="" v-if="step == 4">
          <ion-row>
            <ion-col>
              <ion-item lines="none">
                <ion-label position="stacked">Passwort*</ion-label>
                <ion-input
                  :type="passwordType"
                  v-model="formInput['Password']"
                  autocomplete="off"
                  :clearOnEdit="false"
                  class="u-pointer-auto">
                  <ion-button
                    fill="clear"
                    slot="end"
                    @click="togglePasswordType()"
                    style="order: 1"
                    tabindex="-1">
                    <ion-icon :icon="passwordIcon" slot="icon-only"></ion-icon
                  ></ion-button>
                </ion-input>
              </ion-item>
              <ion-row class="c-help">
                <ion-col size="auto">
                  <ion-icon :icon="helpCircle"></ion-icon>
                </ion-col>
                <ion-col>
                  Bitte wählen Sie ein sicheres Passwort mit mindestens 8
                  Stellen, 1 Kleinbuchstabe, 1 Großbuchstabe, 1 Sonderzeichen
                  und 1 Ziffer.
                </ion-col>
              </ion-row>
              <input-error id="Password" />
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-item lines="none">
                <ion-label position="stacked">Passwort wiederholen*</ion-label>
                <ion-input
                  :type="passwordType"
                  v-model="formInput['PasswordRepeat']"
                  @input="checkPassword($event)"
                  autocomplete="off"
                  :clearOnEdit="false"
                  class="u-pointer-auto">
                  <ion-button
                    fill="clear"
                    slot="end"
                    @click="togglePasswordType()"
                    style="order: 1"
                    tabindex="-1">
                    <ion-icon :icon="passwordIcon" slot="icon-only"></ion-icon
                  ></ion-button>
                </ion-input>
              </ion-item>
              <input-error id="PasswordRepeat" />
            </ion-col>
          </ion-row>
        </template>

        <template class="" v-if="step == 5">
          <ion-row>
            <ion-col>
              <div class="ion-text-center">
                <ion-icon
                  :src="require('@lib/assets/icons/roodie-white.svg')"
                  size="large" />
              </div>
              <h1><b>Willkommen bei Roodie!</b></h1>
              <p>
                <b>
                  Wir haben Ihnen ein Mail an die angegebene Adresse geschickt.
                  Bitte klicken Sie noch auf Bestätigen und schon steht Ihr
                  Gesundheitsnavi für Sie bereit.
                </b>
              </p>
              <ion-row style="align-items: center">
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/white/icon_erstdiagnose.svg')
                    " />
                </ion-col>
                <ion-col>
                  <b>Hilfe bei der Arzt-/Kliniksuche</b>
                </ion-col>
              </ion-row>
              <ion-row style="align-items: center">
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/white/icon_artzwechsel.svg')
                    " />
                </ion-col>
                <ion-col>
                  <b>Zweitmeinung für mehr Sicherheit</b>
                </ion-col>
              </ion-row>
              <ion-row style="align-items: center">
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/white/icon_telefon.svg')
                    " />
                </ion-col>
                <ion-col>
                  <b>Fernbehandlung für Erstabklärungen</b>
                </ion-col>
              </ion-row>
              <ion-row style="align-items: center">
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/white/icon_verlaufskontrolle.svg')
                    " />
                </ion-col>
                <ion-col>
                  <b
                    >Gesundheitsassistenten helfen bei der Organisation (Reha,
                    etc.)</b
                  >
                </ion-col>
              </ion-row>
              <!-- <p>
                Roodie ist Ihr Gesundheitsnavi und bringt Sie schnell zum
                richtigen Arzt - für eine erfolgreiche Behandlung oder
                Operation.
              </p> -->
            </ion-col>
          </ion-row>
        </template>

        <ion-row>
          <ion-col class="ion-text-right">
            <!-- <ion-button v-if="step > 1" @click="step -= 1" color="secondary"
              >Prev</ion-button
            > -->
            <ion-button
              v-if="
                step < Object.keys(stepData).length && (step !== 2 || hasCode)
              "
              @click="submitStep()"
              fill="outline"
              color="primary"
              class="ion-margin-top"
              :disabled="
                (step === 4 &&
                  (formInput['Password'] !== formInput['PasswordRepeat'] ||
                    formInput['Password'] === '' ||
                    formInput['PasswordRepeat'] === '')) ||
                (step === 2 && formInput.MsisdnCode === '')
              "
              >Weiter</ion-button
            >
            <ion-button
              v-if="step == Object.keys(stepData).length"
              color="light"
              class="gtm-registered"
              fill="outline"
              @click="$router.replace({ name: 'login' })"
              >Los geht‘s</ion-button
            >
          </ion-col>
        </ion-row>
        <branding
          v-if="step == Object.keys(stepData).length"
          style="margin-top: auto" />
        <!-- <ion-row
          class="ion-margin-top ion-padding-top"
          v-if="step == Object.keys(stepData).length"
        >
          <ion-col size="auto">
            <ion-icon :src="require('@lib/assets/icons/info.svg')" />
          </ion-col>
          <ion-col>
            <ion-text color="primary" class="u-xsmall">
              ARAG erstattet vollversicherten Kunden immer die Kosten im
              tariflichen Rahmen – natürlich auch, wenn Sie einen anderen
              Serviceanbieter wählen.
            </ion-text>
          </ion-col>
        </ion-row> -->
      </ion-grid>
    </ion-content>

    <!-- <ion-modal
      :is-open="showNotificationSetupModal"
      :css-class="['c-autoheight-modal']"
      @didDismiss="showNotificationSetupModal = false"
    >
      <ion-page>
        <div class="ion-padding modal-content ion-text-center">
          <modal-close />
          <div class="ion-margin-bottom">
            <img width="50" src="@lib/assets/icons/notification.svg" />
          </div>
          <b>Wir schauen darauf, dass Sie alles immer im Auge behalten.</b>
          <p>
            Aktivieren Sie Benachrichtigungen, damit wir Sie an Ihre Arzttermine
            erinnern, Terminbestätigungen schicken und Sie bestmöglich
            unterstützen können, gesund zu bleiben oder schnell wieder gesund zu
            werden.
          </p>
          <ion-button fill="outline" @click="activateNotifications"
            >Aktivieren</ion-button
          >
          <br />
          <ion-button fill="clear" @click="showNotificationSetupModal = false"
            >Später</ion-button
          >
        </div>
      </ion-page>
    </ion-modal> -->
  </ion-page>
</template>

<style lang="scss" scoped>
// ion-grid {
//   ion-row {
//     ion-col {
//       ion-label {
//         color: #9a9797;
//         width: 100%;
//         display: block;
//         margin-bottom: 10px;
//       }

//       ion-select {
//         border: 1px solid #cccc;
//         padding: 10px;
//         border-radius: 45px;
//       }
//     }
//   }
// }

// .c-stepper {
//   margin-bottom: 40px;
//   &__bar {
//     display: flex;
//     justify-content: space-between;
//     position: relative;
//     &:before {
//       content: "";
//       display: block;
//       width: 100%;
//       border-bottom: solid 1px #000;
//       position: absolute;
//       left: 0;
//       top: 50%;
//     }
//   }
//   &__dot {
//     background: #fff;
//     position: relative;
//     padding: 20px;
//     &:before {
//       content: "";
//       display: block;
//       border: solid 1px var(--ion-color-primary);
//       border-radius: 50px;
//       width: 20px;
//       height: 20px;
//     }

//     &.-done {
//       &:before {
//         background: var(--ion-color-primary);
//       }
//     }
//   }
// }

.c-stepper {
  margin-bottom: 40px;
  &__text {
    font-size: 16px;
  }
  &__bar {
    overflow: hidden; //hack for float
    margin-top: 40px;
    margin-bottom: 40px;
    // display: flex;
    // justify-content: space-between;
    // position: relative;
    // &:before {
    //   content: "";
    //   display: block;
    //   width: 100%;
    //   border-bottom: solid 1px #000;
    //   position: absolute;
    //   left: 0;
    //   top: 50%;
    // }
  }
  &__dot {
    // background: #fff;
    position: relative;
    // padding: 20px;
    width: 25%;
    float: left;

    &:before {
      content: "";
      display: block;
      border: solid 1px var(--ion-color-medium-shade);
      border-radius: 50px;
      width: 12px;
      height: 12px;
      margin: 0 auto;

      background: #fff;
      position: relative;
      z-index: 9;
    }

    &:first-child {
      &:after {
        content: none;
      }
    }
    &:after {
      content: "";
      display: block;
      width: calc(100% - 40px);
      transform: translateX(20px); // width / 2
      height: 1px;
      position: absolute;
      left: -50%;
      top: 50%;
      background: var(--ion-color-medium-shade);
    }

    &.-done {
      & + div {
        &:after {
          background: var(--ion-color-primary);
        }
      }
      &:before {
        background: var(--ion-color-primary);
        border-color: var(--ion-color-primary);
      }
    }
  }
}
</style>

<script>
import axios from "@/plugins/axios";
import { getDataString } from "@/utils/basics";
import { DateFormatter } from "@/utils/basics/date";
import InputError from "@/components/InputError";
import { isPlatform } from "@ionic/vue";
// import ModalClose from "@lib/components/ModalClose";
import { chevronBack, helpCircle, eye, eyeOff } from "ionicons/icons";
import InfoModal from "@lib/components/InfoModal";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  // IonTitle,
  IonContent,
  IonInput,
  IonLabel,
  IonItem,
  IonButton,
  IonCheckbox,
  // IonDatetime,
  IonSelect,
  IonSelectOption,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonButtons,
  // IonModal,
  modalController,
  // toastController,
  IonText,
  IonBackButton,
} from "@ionic/vue";
import Branding from "@/components/Branding";
import { IMaskDirective } from "vue-imask";
import { imask } from "@/mixins/imask";
import { generalPrivacyPolicy, generalUsagePolicy } from "@/utils/basics";
// import { apiAddUserTag } from "@/api/user";

export default {
  name: "Registrierung",
  directives: {
    imask: IMaskDirective,
  },
  mixins: [imask],
  components: {
    IonInput,
    IonLabel,
    IonItem,
    IonButton,
    IonCheckbox,
    IonHeader,
    IonToolbar,
    // IonTitle,
    IonContent,
    IonPage,
    // IonDatetime,
    IonSelect,
    IonSelectOption,
    InputError,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
    IonButtons,
    // IonModal,
    // ModalClose,
    IonText,
    Branding,
    IonBackButton,
  },
  watch: {
    step(newVal) {
      this.$gtm.trackView(
        "Schritt " + newVal + " - " + this.stepData[newVal].text,
        "/registrierung/" + newVal
      );
      // if (newVal === 2) {
      //   this.formInput.MsisdnCode = "";
      // }
    },
  },
  mounted() {
    this.step = 1;
  },
  methods: {
    // async activateNotifications() {
    //   this.$store.commit("setShowLoading", true);
    //   const response = await apiAddUserTag("notifications");
    //   if (response.data.Status === "Success") {
    //     const toast = await toastController.create({
    //       message: "Wir benachrichtigen Sie, sobald das Service verfügbar ist.",
    //       duration: 2000,
    //     });
    //     toast.present();
    //     this.showNotificationSetupModal = false;
    //   }
    // },
    async openInfoModal(title, text) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "my-custom-class",
        componentProps: {
          title: title,
          text: text,
        },
      });
      return modal.present();
    },
    togglePasswordType() {
      if (this.passwordType === "password") {
        this.passwordType = "text";
        this.passwordIcon = eyeOff;
      } else {
        this.passwordType = "password";
        this.passwordIcon = eye;
      }
    },
    checkPassword(event) {
      // console.log(this.formInput.Password);
      // console.log(this.formInput.PasswordRepeat);
      // alert(event.target.value);
      if (this.formInput.Password !== event.target.value) {
        this.$store.commit("setErrors", {
          PasswordRepeat: "Passwörter stimmen nicht überein",
        });
      } else {
        this.$store.commit("setErrors", {});
      }
    },
    sendVerifySms() {
      this.sendCodeCountdown--;
      this.$store.commit("setShowLoading", true);
      axios
        .post(
          "?Mode=General&Function=SendVerifySms",
          "Msisdn=" + this.formInput["Msisdn"]
        )
        .then((response) => {
          if (response.data.Status === "Success") {
            const interval = setInterval(() => {
              this.sendCodeCountdown--;
              if (this.sendCodeCountdown === 0) {
                clearInterval(interval);
                this.sendCodeCountdown = 30;
              }
            }, 1000);
          } else {
            this.sendCodeCountdown = 30;
          }
          this.$nextTick(() => {
            this.$refs.codeInput.$el.setFocus();
          });
        });
    },
    async submitStep() {
      if (this.step === 2) {
        this.$store.commit("setShowLoading", true);
        const verifySmsResponse = await axios.post(
          "?Mode=General&Function=VerifySms",
          "Msisdn=" +
            this.formInput.Msisdn +
            "&MsisdnCode=" +
            this.formInput.MsisdnCode
        );
        if (verifySmsResponse.data.Status === "Error") {
          return;
        }
      }

      const changedFormInput = { ...this.formInput };
      changedFormInput["BirthDate"] = DateFormatter.formatDate(
        new Date(changedFormInput["BirthDate"].split(".").reverse().join("-")),
        "YYYY-MM-DD"
      );

      const dataString = getDataString(changedFormInput);

      console.log(dataString);

      this.$store.commit("setErrors", {});
      this.$store.commit("setShowLoading", true);
      axios
        .post("?Mode=General&Function=Register", dataString)
        .then((response) => {
          // alert("asd");
          console.log(response);
          let hasStepError = false;
          if (response.data.Status === "Error") {
            // console.log(this.stepData[this.step].errors.length);
            if (this.stepData[this.step].errors.length) {
              for (const error of this.stepData[this.step].errors) {
                if (response.data.Errors[error]) {
                  this.$store.commit("setErrors", response.data.Errors);
                  hasStepError = true;
                }
              }
              if (response.data.Errors.General) {
                this.$store.commit(
                  "setErrorMessage",
                  response.data.Errors.General
                );
                this.$store.commit("setShowErrorMessage", true);
                hasStepError = true;
              }
            }
            if (!hasStepError) {
              this.step++;
            }
          } else if (response.data.Status === "Success") {
            this.step++;
          }

          // if (this.step === 5) {
          //   this.showNotificationSetupModal = true;
          // }
        });
    },
  },

  setup() {
    return {
      chevronBack,
      helpCircle,
    };
  },

  data() {
    return {
      step: 0,
      generalPrivacyPolicy: generalPrivacyPolicy,
      generalUsagePolicy: generalUsagePolicy,
      hasCode: false,
      sendCodeCountdown: 30,
      passwordType: "password",
      passwordIcon: eye,
      // showNotificationSetupModal: false,
      isPlatform: isPlatform,
      formInput: {
        BirthDate: "",
        ExternalId: "",
        Email: "",
        Msisdn: "",
        MsisdnCode: "",
        Initials: "",
        Firstname: "",
        Lastname: "",
        Street: "",
        Housenumber: "",
        Zip: "",
        City: "",
        Country: "Deutschland",
        Password: "",
        PasswordRepeat: "",
        TermsAccepted: false,
      },
      stepData: {
        1: {
          text: "Gleich kann’s losgehen! Roodie braucht nur ein paar Informationen:",
          errors: ["BirthDate", "ExternalId", "AGB", "TermsAccepted"],
        },
        2: {
          text: "Gleich kann’s losgehen! Roodie braucht nur ein paar Informationen:",
          errors: ["Email", "Msisdn", "MsisdnCode"],
        },
        3: {
          text: "Ihre Roodie Daten",
          errors: [
            "Initials",
            "Firstname",
            "Lastname",
            "Street",
            "Housenumber",
            "Zip",
            "City",
          ],
        },
        4: {
          text: "Ihr Roodie Schutz",
          errors: ["Password"],
        },
        5: {
          text: "Willkommen bei Roodie!",
          errors: [],
        },
      },
    };
  },
};
</script>
